import { render } from "./DashboardTransactionListCmp.vue?vue&type=template&id=477ba835"
import script from "./DashboardTransactionListCmp.vue?vue&type=script&lang=js"
export * from "./DashboardTransactionListCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__